import PhotoFallback, { usePhotoFailure } from "@/modules/project/ui/photo-fallback";

interface Props {
  src: string;
  alt: string;
}

// 고객 화면 사진 한 칸 — 누르면 원본을 새 탭으로, 안 뜨면 이유(링크 만료·없음·잠시 후)를 보인다.
const CustomerPhotoThumb = ({ src, alt }: Props) => {
  const { failure, onError } = usePhotoFailure(src, "customer");
  if (failure) return <PhotoFallback className="aspect-square w-full rounded-md" failure={failure} />;
  return (
    <a className="block aspect-square w-full overflow-hidden rounded-md" href={src} rel="noopener" target="_blank">
      <img alt={alt} className="size-full object-cover" loading="lazy" src={src} onError={onError} />
    </a>
  );
};

export default CustomerPhotoThumb;
